<template>
	<el-dialog :title="mode === 'add' ? '新建书单' : '修改书单'" :visible.sync="localVisible" width="540px" append-to-body :close-on-click-modal="false" @close="handleClose">
		<el-form @submit.native.prevent :model="form" :rules="rules" ref="formRef" label-width="80px" label-position="top">
			<el-row :gutter="20">
				<el-col :span="24">
					<el-form-item label="书单名称" prop="catalogName">
						<el-input v-model="form.catalogName" placeholder="请输入书单名称" maxlength="40" show-word-limit />
					</el-form-item>
				</el-col>
				<el-col :span="24">
					<el-form-item label="排序" prop="seqSort">
						<el-input-number v-model="form.seqSort" :min="1" :max="999" :step="1" style="width: 160px" />
					</el-form-item>
				</el-col>
				<!-- <el-col :span="24">
					<el-form-item label="描述">
						<el-input v-model="form.catalogDesc" placeholder="请输入描述（选填）" type="textarea" :rows="2" maxlength="200" show-word-limit />
					</el-form-item>
				</el-col> -->
			</el-row>
		</el-form>
		<div slot="footer">
			<el-button @click="handleClose">取消</el-button>
			<el-button type="primary" :loading="loading" @click="handleConfirm">确定</el-button>
		</div>
	</el-dialog>
</template>

<script>
import { postPersonalBookAdd, putPersonalBookUpdate } from '@/api/book/personalBook.js';
import { getMemberBookListCheckName } from '@/api/book/book.js';

export default {
	name: 'DialogFolderCompany',
	data() {
		return {
			localVisible: false,
			loading: false,
			mode: 'add', // 'add' | 'edit'
			form: {
				id: null,
				catalogName: '',
				catalogDesc: '',
				seqSort: 1,
				catalogType: 2
			},
			rules: {
				catalogName: [{ required: true, message: '请输入书单名称', trigger: 'blur' }],
				seqSort: [{ required: true, message: '请输入排序', trigger: 'blur' }]
			}
		};
	},
	methods: {
		/**
		 * 打开弹窗
		 * @param {Object|null} data - 传入数据时为编辑模式，否则为新增模式
		 */
		open(data = null) {
			if (data) {
				this.mode = 'edit';
				this.form = {
					id: data.id,
					catalogName: data.catalogName || data.name || '',
					catalogDesc: data.catalogDesc || data.desc || '',
					seqSort: data.seqSort || 1,
					catalogType:  2
				};
			} else {
				this.mode = 'add';
				this.form = { id: null, catalogName: '', catalogDesc: '', seqSort: 1, catalogType: 2 };
			}
			this.localVisible = true;
			this.$nextTick(() => {
				this.$refs.formRef && this.$refs.formRef.clearValidate();
			});
		},

		handleClose() {
			this.localVisible = false;
			this.$emit('cancel');
		},

		async handleConfirm() {
			const valid = await this.$refs.formRef.validate().catch(() => false);
			if (!valid) return;
			this.loading = true;
			try {
				const params = { ...this.form };
				// 新增时校验名称是否重复
				if (this.mode === 'add') {
					params.catalogName = await this.resolveUniqueName(params.catalogName);
				}
				if (this.mode === 'add') delete params.id;
				const api = this.mode === 'add' ? postPersonalBookAdd : putPersonalBookUpdate;
				const res = await api(params);
				this.$message.success(this.mode === 'add' ? '书单创建成功' : '书单修改成功');
				this.localVisible = false;
				this.$emit('success', res.data || params, this.mode);
			} catch (err) {
				this.$message.error(err.message || '操作失败');
			} finally {
				this.loading = false;
			}
		},

		// 校验名称是否重复，重复则生成 "副本（1）" "副本（2）" ...
		async resolveUniqueName(baseName) {
			const checkRes = await getMemberBookListCheckName({
				catalogName: baseName,
				catalogType: this.form.catalogType
			});
			if (!(checkRes.code == 200 && checkRes.data)) {
				return baseName;
			}
			let index = 1;
			while (index < 100) {
				const candidate = `${baseName} 副本（${index}）`;
				const res = await getMemberBookListCheckName({
					catalogName: candidate,
					catalogType: this.form.catalogType
				});
				if (!(res.code == 200 && res.data)) {
					return candidate;
				}
				index++;
			}
			return `${baseName} 副本（${Date.now()}）`;
		}
	}
};
</script>

<style lang="less" scoped>
// 弹出框重置样式
/deep/ .el-dialog__header {
	border-bottom: 1px solid #e8e8e8;
	margin-right: 0;
	background: #f8fafc;
}

/deep/ .el-dialog__headerbtn .el-dialog__close {
	color: #3a434f;
	font-size: 24px;
}

/deep/ .el-dialog__footer {
	border-top: 1px solid #e8e8e8;
	padding: 18px;
}

/deep/ .el-dialog__body .el-form-item__label {
	line-height: 26px;
}
</style>
